/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

import { StreamTimelineConfiguration } from './model/StreamTimelineConfiguration';
import { StreamTimelineManager } from './StreamTimelineManager';
import { DefaultStreamTimelineManager } from './internal/StreamTimelineManagerImpl';
import { Logger } from '@quickplay/foundation';
import { EventStore } from './EventStore';
import { FirebaseEventStore } from './internal/FirebaseEventStoreImpl';
import { Player } from '@quickplay/player-interface';

/**
 * Returns a stream timeline manager instance.
 * @param streamTimelineConfiguration the stream timeline configuration
 * @param player the player instance
 * @param logger optional logger
 */
export function createStreamTimelineManager(
  streamTimelineConfiguration: StreamTimelineConfiguration,
  player: Player,
  logger?: Logger,
): StreamTimelineManager {
  const eventStore: EventStore = new FirebaseEventStore(streamTimelineConfiguration, player, logger);
  return new DefaultStreamTimelineManager(streamTimelineConfiguration, eventStore, logger);
}
